import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { ConditionsSection } from './components/ConditionsSection';
import { PracticeSection } from './components/PracticeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
type FbqFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: FbqFn;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: FbqFn;
    _fbq?: FbqFn;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  /* Meta Pixel Code */
  useEffect(() => {
    if (window.fbq) return;
    const n = function (...args: unknown[]) {
      if (n.callMethod) n.callMethod(...args);else n.queue.push(args);
    } as FbqFn;
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    n('init', PIXEL_ID);
    n('track', 'PageView');
  }, []);
  /* End Meta Pixel Code */

  return <div className="min-h-screen w-full bg-brand-ivory font-sans text-brand-petrol selection:bg-brand-mint selection:text-brand-petrol" data-id="element-0" data-mp="nvar1p5ifbf2">
      <noscript data-id="element-1" data-mp="3684hdq2uasw">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="35oz0whm5evr" />
      </noscript>

      <Hero data-id="element-3" data-mp="d3cuxpqygsfi" />
      <main data-id="element-4" data-mp="d45ua5nl4fnm">
        <ProblemSection data-id="element-5" data-mp="d2l936n5u92f" />
        <SolutionSection data-id="element-6" data-mp="85l0op2u8u85" />
        <BonusesSection data-id="element-7" data-mp="85bc95xfyv4k" />
        <BenefitsSection data-id="element-8" data-mp="8648hcyry28g" />
        <OfferSection data-id="element-9" data-mp="83qhpgb4nc6p" />
        <ConditionsSection data-id="element-10" data-mp="3gl4qtf87pwiz" />
        <PracticeSection data-id="element-11" data-mp="3gmfuzg5kl6am" />
        <Testimonials data-id="element-12" data-mp="3glny8208l2ir" />
        <FAQSection data-id="element-13" data-mp="3bmbdpnwu87jc" />
        <FinalCTA data-id="element-14" data-mp="3bmtij8xkfu2v" />
      </main>
      <Footer data-id="element-15" data-mp="3bnmerfywf16r" />
      {showPurchasePopup && <PurchasePopup data-id="element-16" data-mp="3bkgse8hnmdeq" />}
    </div>;
}